// extracted by mini-css-extract-plugin
export default {"wrap":"sG-z","subtitle":"tG-z","contentWrap":"uG-z","imgWrap":"vG-z","heading":"wG-z","copy":"xG-z"};